module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bold-webfont.4a175597.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bold-webfont.eot
// module id = 100
// module chunks = 3